"use client";

import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import TopNavThree from "../../components/Header/TopNav/TopNavThree";
import MenuFurniture from "../../components/Header/Menu/MenuFurniture";
import ShopBreadCrumbImg from "../../components/Shop/ShopBreadCrumbImg";
import Footer from "../../components/Footer/Footer";
import { fetchProductImages, fetchProductText } from "../../data/Productlist";
import { ProductType } from "../../type/ProductType";

const Shop: React.FC = () => {
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category") || "";

  const [dataSourceProd, setDataSourceProd] = useState<ProductType[]>([]);
  const [isOpenProduct, setIsOpenProduct] = useState(false);
  const [isLoadingText, setIsLoadingText] = useState(true);
  const [isLoadingImages, setIsLoadingImages] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const products = await fetchProductText();
        setDataSourceProd(products);
        setIsOpenProduct(true);
        setIsLoadingText(false);

        const productsWithImages = await fetchProductImages(products);
        setDataSourceProd(productsWithImages);
        setIsLoadingImages(false);
      } catch (error) {
        console.error("Failed to fetch products:", error);
        setDataSourceProd([]);
        setIsOpenProduct(true);
        setIsLoadingText(false);
        setIsLoadingImages(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    document.title = "Boutique | Kissaria";
  }, []);

  if (!isOpenProduct || isLoadingText || isLoadingImages) {
    return (
      <div className="flex justify-center items-center h-screen bg-gradient-to-br from-pink-50 to-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-pink-500 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Chargement de la boutique...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <TopNavThree props="style-three bg-white" />
      <div id="header" className="relative w-full">
        <MenuFurniture props="" />
      </div>
      <ShopBreadCrumbImg
        key={category || "boutique-all"}
        data={dataSourceProd}
        productPerPage={12}
        dataType={category}
      />
      <Footer />
    </>
  );
};

export default Shop;
